// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__amkMr","dark":"Footer_dark__228eq","centerInMobile":"Footer_centerInMobile__1R8Eo","logo":"Footer_logo__HYU04","terms":"Footer_terms__D2hxA"};